import {
  ActivityTypeMetricsDto,
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { ELSDropDownOption } from '@els/els-component-form-field-react';
import { SELECT_OPTION } from '../../utilities/app.utilities';

export const getQuestionNumberOptions = (metricCounts: ActivityTypeMetricsDto): ELSDropDownOption[] => {

  const options = [];
  if (!metricCounts) {
    return []
  }

  let maxNumber = metricCounts.activityTypeAttemptGoal
  const totalMissedOrNotDone = metricCounts.activityTypeAttemptGoal - metricCounts.activityTypeTotalGoalProgress

  if (metricCounts.activityTypeTotalGoalProgress < metricCounts.activityTypeAttemptGoal) {
    maxNumber = totalMissedOrNotDone
  }

  // Can only know the incorrect count once all questions have been attempted
  const incorrectCount = metricCounts.activityTypeAttemptGoalCompleted >= metricCounts.activityTypeAttemptGoal
  && metricCounts.activityTypeTotalGoalCompleted < metricCounts.activityTypeAttemptGoal
    ? metricCounts.activityTypeAttemptGoal - metricCounts.activityTypeTotalGoalCompleted
    : 0

  for (let i = 1; i <= maxNumber; i += 1) {

    const questionText = i === 1 ? 'Question' : 'Questions';

    if (incorrectCount > 0 && incorrectCount === i) {
      options.push({ name: `${i} ${questionText} (all incorrect)`, value: i });
    } else if (totalMissedOrNotDone === i) {
      options.push({ name: `${i} ${questionText} (all remaining)`, value: i });
    } else if (metricCounts.activityTypeAttemptGoal === i) {
      options.push({ name: `${i} ${questionText} (all)`, value: i });
    } else if (i % 5 === 0) {
      options.push({ name: `${i} ${questionText}`, value: i });
    }
  }

  return [
    SELECT_OPTION,
    ...options
  ];

};
